import { DynamicYieldManager } from 'src/app/data/manager/dynamic-yield/dynamic-yield.manager';
import {
  Component,
  OnInit,
  ViewContainerRef,
  ComponentFactoryResolver,
  Injector,
  ViewChild,
  HostListener,
  Inject,
  PLATFORM_ID,
  OnDestroy,
} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {countryConfig} from 'src/country-config/country-config';
import {ResizeService} from './ui/shared/modules/size-detector/resize.service';
import {ScreenSize} from './ui/shared/modules/size-detector/ScreenSize';
import {ResizeEvent} from './ui/shared/event-listeners/resize/resize.event';
import {RootVm} from './view-model/root/root.vm';
import {SessionEvent} from './ui/shared/event-listeners/session/session.event';
import {PageEvent} from './ui/shared/event-listeners/event-page/event-page.event';
import {UpdateOnlineOnlyModalEvent} from './ui/shared/event-listeners/update-online-only-modal/update-online-only-modal.event';
import {UpdateBuyAndGetModalEvent} from './ui/shared/event-listeners/update-buy-and-get-modal/update-buy-and-get-modal.event';
import {SwPush} from '@angular/service-worker';
import {NavigationEnd, Router} from '@angular/router';
import {ScrollInfiniteEvent} from './ui/shared/event-listeners/scroll-infinite/scroll-infinite.event';
import * as storeNgrx from '@ngrx/store';
import {AppState} from './app.reducer';
import {isPlatformBrowser} from '@angular/common';
import {auth} from 'firebase';
import { DYService } from './data/networking/services/dynamic-yield/dynamic-yield.service';
import { ScrollEvent } from './ui/shared/event-listeners/scroll/scroll.event';

declare const window: any;

declare let grecaptcha: {
  enterprise: {
    ready: (callback: () => void) => void;
  };
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ResizeService],
})
export class AppComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  showAllComponents = false;
  idProductOnline = 0;
  screenSize: ScreenSize = {mobile: false, desktop: true};
  private VAPID_PUBLIC_KEY =
    'BDfizNNr0H1PM8cPm2eO7S1faihESYdbuTv5pli3fVOm5mmtfqWkPIg4CBWmhCre3Xx2RwZxvhlIoXmVzjxkYnQ';
  @ViewChild('menuBottom', {read: ViewContainerRef}) menuBottom: ViewContainerRef;
  @ViewChild('helpButton', {read: ViewContainerRef}) helpButton: ViewContainerRef;
  @ViewChild('toast', {read: ViewContainerRef}) toast: ViewContainerRef;

  @ViewChild('customModal', {read: ViewContainerRef}) customModal: ViewContainerRef;
  @ViewChild('productToast', {read: ViewContainerRef}) productToast: ViewContainerRef;
  @ViewChild('onlineOnlyModal', {read: ViewContainerRef}) onlineOnlyModal: ViewContainerRef;
  @ViewChild('buyAndGetModal', {read: ViewContainerRef}) buyAndGetModal: ViewContainerRef;

  @ViewChild('p2cPayModal', {read: ViewContainerRef}) p2cPayModal: ViewContainerRef;
  @ViewChild('p2cInfoModal', {read: ViewContainerRef}) p2cInfoModal: ViewContainerRef;
  @ViewChild('p2cMobile', {read: ViewContainerRef}) p2cMobile: ViewContainerRef;
  @ViewChild('mdlBolivarDigital', {read: ViewContainerRef}) mdlBolivarDigital: ViewContainerRef;
  @ViewChild('mdlAddress', { read: ViewContainerRef }) mdlAddress: ViewContainerRef;
  @ViewChild('openModalSubscribe', {read: ViewContainerRef}) openModalSubscribe: ViewContainerRef;

  @HostListener('window:scroll', ['$event']) onScroll(event) {
    this.scrollEvent.changeScrollWindow(event.target.scrollTop);
    this.callAllComponets();
  }
  isBrowser = false;
  objService = {cursor: null};
  desactiveCssZoom = false;
  hideHeaderAndMenuBottom = false;
  subscriptionList: Subscription[] = [];

  constructor(
    private vm: RootVm,
    private loginEvent: SessionEvent,
    private cfr: ComponentFactoryResolver,
    private injector: Injector,
    private resizeService: ResizeService,
    private resizeEvent: ResizeEvent,
    private eventPage: PageEvent,
    private onlineOnlyEvent: UpdateOnlineOnlyModalEvent,
    private buyAndGetEvent: UpdateBuyAndGetModalEvent,
    private scrollInfinite: ScrollInfiniteEvent,
    private swPush: SwPush,
    private storeNgrx: storeNgrx.Store<AppState>,
    @Inject(PLATFORM_ID) platformId,
    private dyService: DYService,
    private router: Router,
    private dynamicYieldManager: DynamicYieldManager,
    private scrollEvent: ScrollEvent
  ) {
    this.subscribeNotifications();
    this.vm.setPrimeConfig();
    this.isBrowser = isPlatformBrowser(platformId);

    if (isPlatformBrowser(platformId)) {
      const isChrome = window?.navigator?.userAgent;
      this.desactiveCssZoom = !(isChrome.indexOf("Chrome") > -1);
    }
  }

  logPlatformOpenedEvent() {
    const subscription = this.vm
      .logEvent('platform_opened', {
        source: 'direct',
        path: window.location.pathname,
      })
      .pipe(
        catchError(error => {
          console.error('Error logging event:', error);
          return null;
        }),
      )
      .subscribe();

    this.subscriptions.add(subscription);
  }

  ngOnInit(): void {
    this.validateRoute();
    this.dynamicYieldManager.getCookie()
    this.isBrowser && this.getFireAuth();
    this.loadIndexScripts();
    this.vm.getConfigurationMultiCountry();

    if (localStorage.showAllComponents) {
      this.callAllComponets();
    } else {
      this.eventsPage();
    }

    this.storeNgrx.select('saveSubscriptionOutOfStock').subscribe(res => {
      if (res?.show) {
        this.openModalSubscriptionOutOfStock();
      }
    });

    this.logPlatformOpenedEvent();
    this.getCustomTagProduct();
    this.setContextDY();
    this.vm.getInternationalization();
    this.getInitialRemoteConfig();
    this.initializeRecaptcha();
    this.getDeliveryTypeTime();
  }

  onModalScrollDown() {
    if (window.location.pathname !== '/') {
      this.scrollInfinite.changeInfiniteWindow({scrollChange: true});
    }
  }

  callAllComponets() {
    if (!this.showAllComponents) {
      this.showAllComponents = true;
      localStorage.showAllComponents = true;
      this.eventPage.changeEventCallAllComponents({allComponents: true});

      setTimeout(() => {
        this.getAddress();
        this.getMenuBottom();
        this.getToast();
        this.getHelpButton();
        this.getCustomModal();
      }, 10);

      this.onlineOnlyEvent.onlineOnlyProduct.subscribe((product: any) => {
        if (this.isAnOnlineProductAndIsNotOptical(product)) {
          this.idProductOnline = product.id;
        }
      });

      this.buyAndGetEvent.buyAndGetProduct.subscribe(data => {
        if (data) {
          this.getBuyAndGetModal({data, status: {open: true}});
        }
      });

      this.resizeService.onResize$.subscribe(size => {
        this.screenSize = size;
        this.resizeEvent.changeScreenSize(size);
      });

      this.vm.createAnonymous().subscribe(response => {
        if (response) {
          this.loginEvent.changeLoginStatus(false);
        }
      });
      this.vm.validatetokens();
    }
  }

  isAnOnlineProductAndIsNotOptical(product) {
    return product && this.idProductOnline !== product.id && !product.itemOpticsComplete;
  }

  eventsPage() {
    if (!this.showAllComponents) {
      window.addEventListener('click', () => this.callAllComponets());
      window.addEventListener('mouseover', () => this.callAllComponets());
      window.addEventListener('keypress', () => this.callAllComponets());
      window.addEventListener('touchstart', () => this.callAllComponets());
      window.addEventListener('touchmove', () => this.callAllComponets());
    }
  }

  loadIndexScripts() {
    ((w, d, s, l, i) => {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      const f = d.getElementsByTagName(s)[0];
      const j: any = d.createElement(s);
      const dl = l !== 'dataLayer' ? `&l=${l}` : '';
      j.async = true;
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', countryConfig.analytics.gtmContainer);
    ((w, d, s, i) => {
      const f = d.getElementsByTagName(s)[0];
      const j: any = d.createElement(s);
      j.async = true;
      j.src = `https://www.googletagmanager.com/gtag/js?id=${i}`;
      f.parentNode.insertBefore(j, f);

      window.dataLayer = window.dataLayer || [];
      const dataLayer = [...window.dataLayer];
      // eslint-disable-next-line prefer-rest-params
      function gtag() {
        dataLayer.push(arguments);
      }
      // @ts-ignore
      gtag('js', new Date());
      // @ts-ignore
      gtag('config', i);
    })(window, document, 'script', countryConfig.analytics.googleAdsConversionId);
  }

  async getMenuBottom() {
    if (this.menuBottom) {
      this.menuBottom.clear();
      const {MenuBottomComponent} = await import(
        './ui/shared/modules/menu-bottom/menu-bottom.component'
      );
      const factory = this.cfr.resolveComponentFactory(MenuBottomComponent);
      this.menuBottom.createComponent(factory, null, this.injector);
    }
  }

  async getToast() {
    if (this.toast) {
      this.toast.clear();
      const {ToastComponent} = await import('./ui/shared/modules/toast/toast.component');
      const factory = this.cfr.resolveComponentFactory(ToastComponent);
      this.toast.createComponent(factory, null, this.injector);
    }
  }

  async getHelpButton() {
    if (this.helpButton) {
      this.helpButton.clear();
      const {HelpButtonComponent} = await import(
        './ui/shared/modules/help-button/help-button.component'
      );
      const factory = this.cfr.resolveComponentFactory(HelpButtonComponent);
      this.helpButton.createComponent(factory, null, this.injector);
    }
  }

  async getCustomModal() {
    if (this.customModal) {
      this.customModal.clear();
      const {CustomModalComponent} = await import(
        './ui/modals/custom-modal/custom-modal.component'
      );
      const factory = this.cfr.resolveComponentFactory(CustomModalComponent);
      this.customModal.createComponent(factory, null, this.injector);
    }
  }

  async getProductToast() {
    if (this.productToast) {
      this.productToast.clear();
      const {ProductToastComponent} = await import(
        './ui/shared/modules/product-toast/product-toast.component'
      );
      const factory = this.cfr.resolveComponentFactory(ProductToastComponent);
      this.productToast.createComponent(factory, null, this.injector);
    }
  }

  async getOnlineOnlyModal(data) {
    const {product, status} = data;
    if (this.onlineOnlyModal) {
      this.onlineOnlyModal.clear();
    }
    const {OnlineOnlyModalComponent} = await import(
      './ui/modals/online-only-modal/online-only-modal.component'
    );
    const factory = this.cfr.resolveComponentFactory(OnlineOnlyModalComponent);
    const {instance} = this.onlineOnlyModal.createComponent(factory, null, this.injector);
    instance.product = product;
    setTimeout(() => {
      instance.modalStatus = status;
    }, 100);
  }

  async getBuyAndGetModal(data) {
    const {status} = data;
    if (this.buyAndGetModal) {
      this.buyAndGetModal.clear();
    }
    const {BuyAndGetComponent} = await import('./ui/modals/buy-and-get/buy-and-get.component');
    const factory = this.cfr.resolveComponentFactory(BuyAndGetComponent);
    const {instance} = this.buyAndGetModal.createComponent(factory, null, this.injector);
    instance.data = data.data.data;
    setTimeout(() => {
      instance.buyAndGetModalStatus = status;
    }, 100);
  }

  async getP2cPayModal() {
    if (this.p2cPayModal) {
      this.p2cPayModal.clear();
      const {P2cPayModalComponent} = await import('./ui/modals/p2c-pay/p2c-pay-modal.component');
      const factory = this.cfr.resolveComponentFactory(P2cPayModalComponent);
      this.p2cPayModal.createComponent(factory, null, this.injector);
    }
  }

  async getP2cInfoModal() {
    if (this.p2cInfoModal) {
      this.p2cInfoModal.clear();
    }
    const {P2cInfoModalComponent} = await import('./ui/modals/p2c-info/p2c-info-modal.component');
    const factory = this.cfr.resolveComponentFactory(P2cInfoModalComponent);
    this.p2cInfoModal.createComponent(factory, null, this.injector);
  }

  async getBolivarDigital() {
    if (this.mdlBolivarDigital) {
      this.mdlBolivarDigital.clear();
    }
    const {BolivarDigitalModal} = await import(
      './ui/modals/bolivar-digital/bolivar-digital.component'
    );
    const factory = this.cfr.resolveComponentFactory(BolivarDigitalModal);
    this.mdlBolivarDigital.createComponent(factory, null, this.injector);
  }

  async getAddress() {
    if (this.mdlAddress) { this.mdlAddress.clear(); }
    const { AddressComponent } = await import('./ui/shared/modules/address/address.module');
    const factory = this.cfr.resolveComponentFactory(AddressComponent);
    this.mdlAddress.createComponent(factory, null, this.injector);
  }

  subscribeNotifications(): any {
    this.swPush
      .requestSubscription({
        serverPublicKey: this.VAPID_PUBLIC_KEY,
      })
      .then(sub => {});
  }
  async openModalSubscriptionOutOfStock() {
    if (this.openModalSubscribe) {
      this.openModalSubscribe.clear();
      const {SubscribeProductAvailableComponent} = await import(
        './ui/modals/subscribe-product-available/subscribe-product-available.component'
      );
      const factory = this.cfr.resolveComponentFactory(SubscribeProductAvailableComponent);
      this.openModalSubscribe.createComponent(factory, null, this.injector);
    }
  }

  getFireAuth() {
    auth().signInAnonymously().then();
  }

  getUserOrders(data) {
    const customer = this.vm.getLsCustomer();
    if(!customer) return;
    this.vm.getUserOrders(data).subscribe(orders => {
      if (orders && orders?.previousOrders?.length > 0) {
        this.vm.saveFirstPurchaseOrders(false);
      } else {
        this.vm.saveFirstPurchaseOrders(true);
      }
    }, err => {
      this.vm.saveFirstPurchaseOrders( false );
    })
  }

  getCustomTagProduct() {
    this.vm.getPropertyCustomTagProduct();
  }
  
  private setContextDY() {
    const current = this.router.getCurrentNavigation();
    const excludeRoutes = [ '/producto', '/carrito', '/categorias']; 
    const currentUrl = current.finalUrl.toString().trim();
  
    if (excludeRoutes.some(route => currentUrl.startsWith(route)) || currentUrl === '/') {
       return;
    }

    this.dyService.setContext('OTHER');
  }

  validateRoute() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.router.events.subscribe(routerEvent => {
      if (routerEvent instanceof NavigationEnd) {
        this.hideHeaderAndMenuBottom = (routerEvent.url.includes('/registro-express') && isSafari);
      }
    });
  }

  getInitialRemoteConfig(): void {
    if (!this.isBrowser) { return; }
    
    this.vm.getInitialRemoteConfig();
  }

  ngAfterViewInit() {
    this.setContextDY();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.subscriptionList?.forEach(subscription => subscription?.unsubscribe());
  }

  initializeRecaptcha() {
   grecaptcha.enterprise.ready(() => {
    this.vm.actionsRecaptcha('homepage');
   });
  }

  getDeliveryTypeTime(): void {
    const subscription = this.vm.getDeliveryTypeTimeFromService().subscribe();
    this.subscriptionList.push(subscription);
  }
}
